import { render } from "./TeacherPayment.vue?vue&type=template&id=30ae40f0&scoped=true"
import script from "./TeacherPayment.vue?vue&type=script&lang=js"
export * from "./TeacherPayment.vue?vue&type=script&lang=js"

import "./TeacherPayment.vue?vue&type=style&index=0&id=30ae40f0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30ae40f0"]])

export default __exports__